import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f12ded62"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "report-card-messages-container"
}
const _hoisted_2 = { key: 1 }

import { computed, ref, watch } from 'vue'
import type { Ref } from 'vue'
import store from '@/mobile/src/store'
import router from '@/mobile/src/router'
import Typography from '@/components/Rain/Typography/Typography.vue'
import Carousel from '@/components/Rain/Layouts/Carousel/Carousel.vue'
import LoadingCard from '@/mobile/src/components/appV4/LoadingCard.vue'
import { IMessage } from '@/entities/notices'
import { Moment } from '@/entities/moment'
import MomentCard from '@/mobile/src/components/appV4/MomentCard.vue'

interface Props {
    title: string
    isLoading: boolean
    messages?: any[]
    closePopup: () => void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportCardMessages',
  props: {
    title: {},
    isLoading: { type: Boolean },
    messages: {},
    closePopup: { type: Function }
  },
  setup(__props: any) {

const props = __props

const moments: Ref<Moment[]> = ref([])

watch(
    () => props.messages,
    () => {
        parseMessagesIntoMoments(props.messages)
    }
)

const parseMessagesIntoMoments = (messages) => {
    moments.value = messages?.map((message) => {
        return {
            id: message.id,
            type: message.type,
            updated: message.created,
            created: message.created,
            message: message.message,
            repliesCount: 0,
            seen: message?.seen,
            user: message?.sender,
            recipientName: message?.recipients?.map(
                (recipient) => recipient.name
            ),
            recipients: message?.recipients,
        }
    })
}

parseMessagesIntoMoments(props.messages)

const navigateToDetail = (messageId: string) => {
    const selectedMessage = props.messages?.find(
        (message) => message.id === messageId
    )
    const selectedQuestionId = selectedMessage?.question_id

    if (selectedQuestionId) {
        props.closePopup()
        router.push(`/feedback/detail/${selectedQuestionId}`)
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createVNode(LoadingCard, { class: "loading-container" }, null, 512), [
      [_vShow, props.isLoading]
    ]),
    (moments.value.length > 0 && !props.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(Typography, {
            class: "topic-title",
            variant: "h4",
            component: "h4"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(props.title), 1)
            ], undefined, true),
            _: 1
          }),
          _createVNode(Carousel, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(moments.value, (moment) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: moment.id,
                  class: "carousel-container"
                }, [
                  (_openBlock(), _createBlock(MomentCard, {
                    key: moment.id,
                    moment: moment,
                    class: "carousel-item",
                    onViewDetail: ($event: any) => (navigateToDetail(moment.id))
                  }, null, 8, ["moment", "onViewDetail"]))
                ]))
              }), 128))
            ], undefined, true),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (moments.value.length > 0)
      ? (_openBlock(), _createElementBlock("hr", _hoisted_2))
      : _createCommentVNode("", true)
  ]))
}
}

})